export default __webpack_public_path__ + "static/media/103.ff2af020.jpeg";